module.exports = __webpack_public_path__ + "media/images/loghi/lba50-84e588585306131f7839f5538238ef72.png";